import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import theme from "../../../theme";

import { convertToLocalCurrency } from "../../../utils/currency";
import { getTopAdvertisers } from "../../../redux/slices/dashboardSlice";
const AllAdvertisers = () => {
  const dispatch = useDispatch();
  const { topAdvertisers } = useSelector((state) => state.dashboard);
  useEffect(() => {
    dispatch(getTopAdvertisers());
  }, [dispatch]);
  return (
    <AdvertiserList>
      {topAdvertisers?.length === 0 ? (
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          No advertiser available.
        </div>
      ) : (
        topAdvertisers?.slice(0, 3).map((advertiser) => (
          <AdvertiserCard>
            <AdvertiserHeader>
              {/* <img src={advertiser.imageUrl} alt={advertiser.name} /> */}
              <h4>
                {advertiser?.firstname} {advertiser?.lastname}
              </h4>
            </AdvertiserHeader>
            <Stats>
              <Stat>
                <Label>Campaigns</Label>
                <Value>{advertiser?.totalcampaigns}</Value>
              </Stat>
              <Stat>
                <Label>Conversions</Label>
                <Value>{advertiser?.totalacquistion}</Value>
              </Stat>
              <Stat>
                <Label>Amount spent</Label>
                <Value>
                  {convertToLocalCurrency(advertiser?.totalamountspent)}
                </Value>
              </Stat>
            </Stats>
          </AdvertiserCard>
        ))
      )}
    </AdvertiserList>
  );
};

export default AllAdvertisers;

const AdvertiserList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const AdvertiserCard = styled.div`
  padding: 16px;
  background: ${theme.color.surfaceAlt};
  border: 1px solid ${theme.color.border};
  border-radius: ${theme.radius.md};
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: ${theme.color.brand};
    background: ${theme.color.surface};
  }
`;
const AdvertiserHeader = styled.div`
  display: flex;
  gap: 20px;

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }
  h4 {
    font-size: ${theme.font.body};
    font-weight: 600;
    color: ${theme.color.text};
    text-transform: capitalize;
  }
`;
const Stats = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 12px;
`;

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  text-align: left;
`;

const Label = styled.span`
  font-size: ${theme.font.tiny};
  color: ${theme.color.textMuted};
`;

const Value = styled.span`
  font-size: ${theme.font.body};
  font-weight: 600;
  color: ${theme.color.text};
`;
